import { Locale } from '../locales';
import plFlag from '../static/img/pl.svg';
import enFlag from '../static/img/gb.svg';
import deFlag from '../static/img/de.svg';

export default function getFlagForLocale(locale: Locale) {
  if (locale === Locale.PL) return plFlag;
  if (locale === Locale.EN) return enFlag;
  if (locale === Locale.DE) return deFlag;
  return plFlag;
}
